import semver from 'semver';
/**
 * Checks if the current version meets the minimum required version
 * @param params - Object containing version parameters
 * @param params.currentVersion - Current version (semver string like "4.31.0")
 * @param params.minimumVersion - Minimum required version (semver string)
 * @returns true if current version >= minimum version
 */
export const meetsMinimumVersion = ({ currentVersion, minimumVersion, }) => {
    if (!currentVersion) {
        return false;
    }
    // Clean version strings (remove 'v' prefix if present, handle rc/beta versions)
    const cleanVersion = semver.coerce(currentVersion);
    const cleanMinVersion = semver.coerce(minimumVersion);
    if (!cleanVersion || !cleanMinVersion) {
        return false;
    }
    return semver.gte(cleanVersion, cleanMinVersion);
};
